<ul class="flex p-bl-1" data-pgr-id="claimHeaderData">
  <cui-claim-header-item>
    <span cui-claim-header-item-label> Claim # </span>
    @if (!isLoading) {
    <cui-copy-button
      [ariaLabel]="
        'Copy claim number ' + headerData?.claimNumber + ' to clipboard'
      "
      [dataToCopy]="headerData?.claimNumber"
    >
      <span cui-claim-header-item-value class="pr-bl-2 text-white">
        {{ headerData?.claimNumber }}
      </span>
    </cui-copy-button>
    } @if (isLoading) {
    <span class="cui-ghost-line inline-block w-10">
      <span class="screen-reader-only">Loading </span>
    </span>
    }
  </cui-claim-header-item>
  <cui-claim-header-item>
    <span cui-claim-header-item-label> Insured </span>
    @if (!isLoading) {
    <span cui-claim-header-item-value class="line-clamp-2 text-white">
      {{ headerData?.insured }}
    </span>
    } @if (isLoading) {
    <span class="cui-ghost-line inline-block w-20">
      <span class="screen-reader-only"> Loading </span>
    </span>
    }
  </cui-claim-header-item>
  <cui-claim-header-item>
    <span cui-claim-header-item-label> Loss Date </span>
    @if (!isLoading) {
    <span cui-claim-header-item-value class="text-white">
      {{ headerData?.dateOfLoss }}
    </span>
    } @if (isLoading) {
    <span class="cui-ghost-line inline-block w-10">
      <span class="screen-reader-only"> Loading </span>
    </span>
    }
  </cui-claim-header-item>
  <cui-claim-header-item>
    <span cui-claim-header-item-label> Since Report </span>
    @if (!isLoading) {
    <span cui-claim-header-item-value class="line-clamp-1 text-white">
      {{ headerData?.timeSinceReport }}
    </span>
    } @if (isLoading) {
    <span class="cui-ghost-line inline-block w-10">
      <span class="screen-reader-only"> Loading </span>
    </span>
    }
  </cui-claim-header-item>
  <cui-claim-header-item>
    <span cui-claim-header-item-label> File Owner </span>
    @if (!isFileOwnerLoading && ownerRepSummary) {
    <cui-popover align="bottom">
      <button
        cui-popover-trigger
        class="cui-popover-link header-link"
        data-pgr-id="btnHeaderContactCard"
      >
        {{ ownerRepSummary.name }} ({{ ownerRepSummary.code }})
      </button>
      <div cui-popover-content>
        <cla-claim-rep-contact-card-redacted
          [rep]="ownerRepSummary"
          cui-popover-content
        ></cla-claim-rep-contact-card-redacted>
      </div>
    </cui-popover>
    } @if (!isFileOwnerLoading && !ownerRepSummary) {
    <span cui-claim-header-item-value class="text-white">
      {{ ownerRepCode }}
    </span>
    } @if (!isFileOwnerLoading && !ownerRepCode) {
    <span cui-claim-header-item-value class="text-white"> Unassigned </span>
    } @if (isFileOwnerLoading) {
    <span class="cui-ghost-line inline-block w-20">
      <span class="screen-reader-only"> Loading </span>
    </span>
    }
  </cui-claim-header-item>
</ul>
